import "./HomeTax.css";
import HeaderProtected from "../../componentes/headerProtected/header";
import Sidebar from "../../componentes/sideBar/SideBar";
import DashboardTax from "../../componentes/fluxo-tax/Request-tax/DashboardTax";
import { SupportFooter } from "../../componentes/supportFooter/supportFooter";

const Dashboard = () => {
  return (
    <>
      <Sidebar />
      <HeaderProtected />
      <div className="homeMain">
        <DashboardTax />
      </div>
      <SupportFooter/>
    </>
  );
};

export default Dashboard;
